<div class="home-block light" id="auditors">
  <div class="home-container">
    <h1>Előadók 2026</h1>
    <div
      class="embla"
      emblaCarousel
      id="embla-auditors"
      [options]="{ loop: true }"
      [plugins]="plugins"
    >
      <div class="embla__container carousel-track">
        @if (isLoading()) {
          <mat-spinner class="mx-auto" strokeWidth="12" />
        } @else {
          @for (a of auditors; track a) {
            <div class="embla__slide">
              <a target="_blank" [href]="a.url">
                <img
                  height="100"
                  loading="lazy"
                  width="200"
                  [alt]="a.alt"
                  [src]="a.file | fileToUrl: 'multimedia/home/szebit_round.webp'"
                />
                <p>{{ a.alt }}</p>
              </a>
            </div>
          }
        }
      </div>
    </div>
  </div>
</div>
